import fetchAvgTrips from './fetchAvgTrips';
import fetchTotalTrips from './fetchTotalTrips';
import { all } from 'redux-saga/effects';

export default function* () {
    yield all([fetchAvgTrips(), fetchTotalTrips()]);
}
